/* eslint-disable no-console */

import { register } from "register-service-worker";

if (import.meta.env.NODE_ENV === "production") {
  register(`${import.meta.env.BASE_URL}service-worker.js`, {
    ready() {
      if (import.meta.env.NODE_ENV != "production")
        // eslint-disable-next-line
        console.log(
          "App is being served from cache by a service worker.\n" + "For more details, visit https://goo.gl/AFskqB"
        );
    },
    registered() {
      if (import.meta.env.NODE_ENV != "production") console.log("Service worker has been registered."); // eslint-disable-line
    },
    cached() {
      if (import.meta.env.NODE_ENV != "production") console.log("Content has been cached for offline use."); // eslint-disable-line
    },
    updatefound() {
      if (import.meta.env.NODE_ENV != "production") console.log("New content is downloading."); // eslint-disable-line
    },
    updated() {
      if (import.meta.env.NODE_ENV != "production") console.log("New content is available; please refresh."); // eslint-disable-line
    },
    offline() {
      if (import.meta.env.NODE_ENV != "production")
        // eslint-disable-next-line
        console.log("No internet connection found. App is running in offline mode.");
    },
    error(error) {
      if (import.meta.env.NODE_ENV != "production") console.error("Error during service worker registration:", error); // eslint-disable-line
    }
  });
}
